import React from "react";
import { useSelector } from "react-redux";
import BookingItem from "./Item";

const BookingTable = () => {
  const booking = useSelector((state) => state.booking);

  return (
    <div className="table-container">
      <table className="booking-table">
        <thead className="bg-gray-100/50">
          <tr className="text-black text-left">
            <th>Destination From</th>
            <th>Destination To</th>
            <th className="text-center">Journey Date</th>
            <th className="text-center">Guests</th>
            <th className="text-center">Class</th>
            <th className="text-center">Delete</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
          {booking.map((item) => (
            <BookingItem key={item.id} item={item} />
          ))}

          {booking.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center" style={{padding: "20px 0"}}>
                No Booking Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BookingTable;
